// This file was auto-generated by Fern from our API Definition.
export const QueryWorkflowVariantsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
